import {
  FETCH_PROJECT_WORKFLOW_DETAILS,
  FETCH_PROJECT_WORKFLOW_DETAILS_START,
  FETCH_PROJECT_WORKFLOW_DETAILS_ERROR,
  FETCH_PROJECT_WORKFLOW_DETAILS_SUCCESS,
  POST_WORKFLOW_STATE,
  POST_WORKFLOW_STATE_START,
  POST_WORKFLOW_STATE_ERROR,
  POST_WORKFLOW_STATE_SUCCESS,
  UPDATE_STATE_TO_CHANGE_TO,
  RESET_STATE_TO_CHANGE_TO
} from './constants'

const fetchProjectWorkflowDetails = (projectId) => ({ type: FETCH_PROJECT_WORKFLOW_DETAILS, projectId })
const fetchProjectWorkflowDetailsStart = () => ({ type: FETCH_PROJECT_WORKFLOW_DETAILS_START })
const fetchProjectWorkflowDetailsSuccess = () => ({ type: FETCH_PROJECT_WORKFLOW_DETAILS_SUCCESS })
const fetchProjectWorkflowDetailsError = (error) => ({ type: FETCH_PROJECT_WORKFLOW_DETAILS_ERROR, error })

const postWorkflowState = (projectId, workflowId, state) => ({ type: POST_WORKFLOW_STATE, projectId, workflowId, state })
const postWorkflowStateStart = () => ({ type: POST_WORKFLOW_STATE_START })
const postWorkflowStateSuccess = () => ({ type: POST_WORKFLOW_STATE_SUCCESS })
const postWorkflowStateError = (error) => ({ type: POST_WORKFLOW_STATE_ERROR, error })

const updateStateToChangeTo = (state) => ({ type: UPDATE_STATE_TO_CHANGE_TO, state})
const resetStateToChangeTo = () => ({ type: RESET_STATE_TO_CHANGE_TO })

export {
  fetchProjectWorkflowDetails,
  fetchProjectWorkflowDetailsStart,
  fetchProjectWorkflowDetailsSuccess,
  fetchProjectWorkflowDetailsError,
  postWorkflowState,
  postWorkflowStateStart,
  postWorkflowStateSuccess,
  postWorkflowStateError,
  updateStateToChangeTo,
  resetStateToChangeTo
}
